import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Input } from 'antd';

export function ReportName(): JSX.Element {
	return (
		<Col xs={24}>
			<Form.Item name="report_name" label={I18n.get('Report name')} labelCol={{ span: 24 }}>
				<Input placeholder={I18n.get('Report name')} />
			</Form.Item>
		</Col>
	);
}
